module.exports = __webpack_public_path__ + "static/media/dsslogo.902009fb.png";